const getItem = sessionItem => JSON.parse(localStorage.getItem(sessionItem));
const setItem = (sessionItem, value) => localStorage.setItem(sessionItem, JSON.stringify(value));

export default {
	setSessionData: (sessionData) => {
		setItem("token", sessionData.token);
		setItem("user", sessionData.user);
		return true;
	},
	isActive: () => {
		const token = localStorage.getItem("token");
		if (token) {
			return true;
		}
		return false;
	},
	clear: () => {
		localStorage.clear();
		return true;
	},
	getItem,
	setItem,
};
